<template>
  <div class="suggested-tags">
    <div v-if="storeErrors['suggestedTags']" class="error-message">{{storeErrors['suggestedTags']}}</div>
    <div v-else-if="!suggestedTags || !suggestedTags.length" class="empty-response">no suggested tags</div>
    <div v-else class="table-container">
      <div class="table-wrapper">
        <table class="suggested-tags-table">
          <thead>
            <th></th>
            <th>brand tag</th>
            <th>retailer</th>
            <th class="hide-for-small">state</th>
            <th></th>
          </thead>
          <tbody>
            <tr v-for="(tag, index) in modifiedSuggestedTags" :key="index">
              <td>
                <div class="delete-link" @click="blacklistTag(tag)">x</div>
              </td>
              <td>{{tag.name}}</td>
              <td>{{tag.retailer}}</td>
              <td class="hide-for-small">{{tag.state}}</td>
              <td class="this-is-me-wrapper" @click="selectedTag(tag)">
                <sb-checkbox class="tag-checkbox" :checked="tag.checked"/>
                this is me
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <button class="button submit-button" :class="{disabled: !hasSelectedTags}" @click="submitSelectedTags">submit</button>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import _ from 'lodash'

  export default {
    props: {
      currentAdvertiserId: Number
    },

    name: 'SuggestedTags',

    data() {
      return {
        selectedTagsIds: [],
        modifiedSuggestedTags: []
      }
    },

    mounted() {
      this.modifiedSuggestedTags = this.suggestedTags.map(tag => ({...tag, checked: false}))
    },

    computed: {
      hasSelectedTags() {
        return !!(this.modifiedSuggestedTags.filter(tag => tag.checked)?.length)
      },
      ...mapState([
        'storeErrors',
        'suggestedTags'
      ])
    },

    methods: {
      blacklistTag(tag) {
        const params = {
          brand_id: this.currentAdvertiserId,
          status: 'blacklisted',
          tags: [{ tag_id: tag.id, merchant_id: tag.merchant_id }]
        }
        this.$emit('updateTag', {params})
      },

      selectedTag(tag) {
        tag.checked = !tag.checked
      },

      submitSelectedTags() {
        const params = {
          status: 'claimed',
          brand_id: this.currentAdvertiserId,
          tags: this.modifiedSuggestedTags.filter(tag => tag.checked).map(tag => {
            if (tag.checked) {
              return {
                tag_id: tag.id,
                merchant_id: tag.merchant_id,
              }
            }
          })
        }
        this.$emit('updateTag', {params})
      }
    },

    watch: {
      suggestedTags(newVal, oldVal) {
        // Check if newVal is the same as oldVal
        if (!!(_.difference(oldVal, newVal))?.length) {
          this.modifiedSuggestedTags = newVal.map(val => ({...val, checked: false}))
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
@import '../../assets/sass/colors'

.suggested-tags
  .table-container
    overflow: auto
    @media only screen and (max-width: 64em)
      display: flex
      flex-direction: column
      justify-content: center

  .table-wrapper
    max-height: 200px
    overflow: auto
    margin-bottom: .75rem
    .this-is-me-wrapper
      display: flex
      justify-content: flex-end
      align-items: center
      color: $primary-color
      cursor: pointer

  .button
    padding: .3rem 1rem
    font-size: 1em
    width: max-content
    margin: auto
    &.disabled
      pointer-events: none
      opacity: .5

  .suggested-tags-table
    width: 100%

  table
    margin: 0 auto
    th
      background: white
      padding: 0 .5rem .5rem .5rem
      position: sticky
      top: 0

    td
      padding: .6rem .5rem

    th:first-child, td:first-child
      padding-right: 0

    td:last-child
      padding: 0 .75rem

    th:nth-child(2)
      text-align: left

  .tag-checkbox
    height: 14px
    width: 14px
    margin-right: .5rem
</style>